import If from '@components/If';
import loadable from '@loadable/component';
import { GoogleNative } from './GoogleNative';
const Web = loadable(() => import('./GoogleWeb'));

interface Props {
  onSuccess: (token: string) => void;
  disabled?: boolean;
}
export const GoogleSwitcher = (props: Props) => {
  return (
    <If conditions={{ web: !IS_NATIVE, native: IS_NATIVE }}>
      {{
        web: () => <Web {...props} />,
        native: () => <GoogleNative {...props} />,
      }}
    </If>
  );
};
